<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import TextareaDefault from '@/components/form/TextareaDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'TextareaForm',

  components: {
    InputLeadFormWrapper,
    TextareaDefault,
  },

  props: {
    /**
     * 初期状態が bind される value
     */
    modelValue: {
      type: String,
      required: true,
    },

    /**
     * placeholder テキスト
     */
    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },

    /**
     * textarea の rows 属性値
     */
    rows: {
      type: Number,
      default: 6,
    },

    ...formDefaultProps,
  },

  emits: ['update:modelValue'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :description="description"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme">
    <TextareaDefault
      :model-value="modelValue"
      :name="name"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :rows="rows"
      :is-disabled="isDisabled"
      :is-error="hasError"
      @update:model-value="$emit('update:modelValue', $event)" />
  </InputLeadFormWrapper>
</template>
